<template>
  <section class="uc-pending-bar" :class="{ 'is-open': expanded }" aria-label="Статус реєстрації">
    <div class="uc-pending-bar__icon" aria-hidden="true">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3 2" />
      </svg>
    </div>

    <span class="uc-pending-bar__badge">На реєстрації</span>

    <p class="uc-pending-bar__text">
      <strong>Документи передано в страхові компанії для реєстрації</strong>
      — поки триває реєстрація, проходьте навчання: запрошення надходитимуть на вашу пошту
    </p>

    <div class="uc-pending-bar__mail">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="3" />
        <path d="M4 7l8 6 8-6" />
      </svg>
      <span>Перевіряйте пошту</span>
    </div>

    <button
      type="button"
      class="uc-pending-bar__toggle"
      :aria-expanded="expanded ? 'true' : 'false'"
      :aria-label="expanded ? 'Згорнути' : 'Відкрити повністю'"
      @click="expanded = !expanded"
    >
      <span class="uc-pending-bar__toggle-text">{{ expanded ? 'Згорнути' : 'Відкрити' }}</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>
  </section>
</template>

<script>
export default {
  name: 'OnboardingPendingBar',
  data () {
    return {
      expanded: false
    }
  }
}
</script>

<style scoped>
.uc-pending-bar {
  --uc-violet-deep: #4555cc;
  --uc-tint: #ebf2ff;
  --uc-ink: #373a3d;
  --uc-ink-soft: #494e53;

  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 64px;
  box-sizing: border-box;
  padding: 10px 20px 10px 12px;
  background: var(--uc-tint);
  border: 1px solid #E2E8F0;
  /*border-radius: 16px;*/
  box-shadow: 0 2px 8px rgba(97, 113, 228, 0.08);
  font-family: Inter, system-ui, sans-serif;
  color: var(--uc-ink);
}

.uc-pending-bar__icon {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--uc-violet-deep);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-pending-bar__badge {
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 999px;
  background: #fff;
  color: var(--uc-violet-deep);
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  white-space: nowrap;
}

.uc-pending-bar__text {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  color: var(--uc-ink-soft);
}

.uc-pending-bar__text strong {
  font-family: 'IBM Plex Sans', system-ui, sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: var(--uc-ink);
}

.uc-pending-bar__mail {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--uc-violet-deep);
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .uc-pending-bar {
    flex-wrap: wrap;
    margin-bottom: 12px;
    border-radius: 8px;
  }

  .uc-pending-bar__text {
    flex-basis: 100%;
    order: 3;
  }
}

.uc-pending-bar__toggle {
  display: none;
}

@media (max-width: 640px) {
  .uc-pending-bar {
    padding: 10px 10px 10px 12px;
  }

  .uc-pending-bar__toggle {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    margin-left: auto;
    padding: 0 8px 0 10px;
    border: 1px solid #d3defa;
    border-radius: 8px;
    background: #fff;
    color: var(--uc-violet-deep);
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }

  .uc-pending-bar__toggle svg {
    transition: transform 0.2s ease;
  }

  .uc-pending-bar.is-open .uc-pending-bar__toggle svg {
    transform: rotate(180deg);
  }

  .uc-pending-bar:not(.is-open) {
    flex-wrap: nowrap;
    gap: 10px;
    min-height: 0;
    padding: 8px 8px 8px 10px;
  }

  .uc-pending-bar:not(.is-open) .uc-pending-bar__icon {
    flex-basis: 32px;
    width: 32px;
    height: 32px;
    border-radius: 9px;
  }

  .uc-pending-bar:not(.is-open) .uc-pending-bar__icon svg {
    width: 18px;
    height: 18px;
  }

  .uc-pending-bar:not(.is-open) .uc-pending-bar__text,
  .uc-pending-bar:not(.is-open) .uc-pending-bar__mail {
    display: none;
  }

  .uc-pending-bar.is-open .uc-pending-bar__mail {
    order: 4;
    flex-basis: 100%;
  }
}
</style>
